import { render, staticRenderFns } from "./DashWeeklyStats.vue?vue&type=template&id=0339b9b2&"
import script from "./DashWeeklyStats.vue?vue&type=script&lang=js&"
export * from "./DashWeeklyStats.vue?vue&type=script&lang=js&"
import style0 from "./DashWeeklyStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports